import React from 'react';
import './GlassStyle.css';

/**
 * Shared frosted-glass page shell for Procure (yellow) and Sources (rose).
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {'yellow'|'rose'|'neutral'|'green'} [props.theme='yellow']
 * @param {boolean} [props.wide=false] - full content width for list/table pages
 * @param {string} [props.testId] - optional hook for page tests
 */
const GlassWorkspaceShell = ({
  children,
  theme = 'yellow',
  wide = false,
  testId,
}) => {
  const themeClass =
    theme === 'rose'
      ? 'glass-page--rose'
      : theme === 'neutral'
        ? 'glass-page--neutral'
        : theme === 'green'
          ? 'glass-page--green'
          : 'glass-page--yellow';
  return (
    <div className={`glass-page ${themeClass}`} data-testid={testId}>
      <div
        className={`glass-page__inner${wide ? ' glass-page__inner--wide' : ''}`}
      >
        {children}
      </div>
    </div>
  );
};

export default GlassWorkspaceShell;
